import React from 'react'

export default ({ children }) => (
    <footer className="footer has-text-centered has-text-primary" style={{ zIndex: 1 }}>
        {children}
        <div><a href="/privacy-policy">Privacy Policy</a></div>
    </footer>
)
